/* eslint-disable no-unused-vars */
import axios from 'axios';
import api from '@src/api';
import moment from 'moment';

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    homeOverview: null,
    progressDetails: null,
    selectedDay: null,
    viewChatList: false,
    isLoadingProgress: false,
  };
}

export const getters = {};

export const mutations = {
  setHomeOverview(state, value) {
    state.homeOverview = value;
  },
  setProgressDetails(state, value) {
    state.progressDetails = value;
  },
  setSelectedDay(state, value) {
    state.selectedDay = value;
  },
  setViewChatList(state, value) {
    state.viewChatList = value;
  },
  setIsLoadingProgress(state, value) {
    state.isLoadingProgress = value;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getHomeOverview(ctx) {
    const todaysDate = moment().format('YYYY-MM-DD');
    if (todaysDate !== undefined) {
      const url = api.URL_GET_HOME_OVERVIEW.replace(':today', todaysDate);

      return axios
        .get(url)
        .then((res) => {
          if (res && res.status === 200) {
            ctx.commit('setHomeOverview', res.data);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(`invalid params (todaysDate) : (${todaysDate})`);
    }
  },
  getProgressDetails(ctx) {
    const todaysDate = moment().format('YYYY-MM-DD');
    if (todaysDate !== undefined) {
      const url = api.URL_GET_PROGRESS_DETAILS.replace(':today', todaysDate);

      return axios
        .get(url)
        .then((res) => {
          if (res && res.status === 200) {
            ctx.commit('setProgressDetails', res.data.progressDetails);
            return res.data.progressDetails;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(`invalid params (todaysDate) : (${todaysDate})`);
    }
  },
};
